import React, { Component } from 'react';
import './index.scss'

class Fail extends Component {
  close= async ()=>{
    let userAgent = navigator.userAgent;
    if (userAgent.indexOf("Firefox") !== -1 || userAgent.indexOf("Chrome") !== -1) {
      window.location.href="about:blank";
    } else {
      window.opener = null;
      window.open("", "_self");
      window.close();
    }
  }
  render() {
    return (
      <div className={'facebook-fail'}>
        <div className={'facebook-close'}>
        </div>
        <div className={'facebook-result'}>
          <img src={require('../../../assets/overseas-share/fail.png')} alt=""/>
        </div>
        <p className={'facebook-title'}>Sharing Failed</p>
        <p className={'facebook-describe'}>It's failed in some reasons try to share again.</p>
      </div>
    );
  }
}

export default Fail;
